/**
 * 官网复用样式片段
 *
 * 官网是桌面优先的站点页（区别于 480px 宽的移动端落地页），
 * 这里把容器、卡片、列表等重复出现的类名收在一处，避免各区块各写一遍。
 * 类名仍走 Tailwind 扫描（content 已包含 src/**\/*.{ts,tsx}），不会被裁掉。
 *
 * 主题色：官网与 App 侧统一用 `primary`（蓝 #01B0FE，见 tailwind.config.js），
 * 不使用落地页的促销红 `brand`。退款表里的红/绿/黄是状态语义色，不随主题走。
 */

export const CONTAINER = "mx-auto w-full max-w-[1120px] px-5 sm:px-6"

export const SECTION = "py-12 sm:py-16"

export const SECTION_SOFT = `${SECTION} border-y border-line bg-page`

export const CARD = "rounded-[20px] border border-line bg-white p-6 shadow-card"

export const PANEL = "rounded-[14px] border border-line bg-white p-5 sm:p-6"

export const EYEBROW =
  "mb-2.5 text-[13px] font-bold uppercase tracking-[0.08em] text-primary"

export const H1 =
  "text-[clamp(28px,4.4vw,44px)] font-bold leading-[1.25] tracking-[-0.01em] text-ink"

export const H2 =
  "text-[clamp(22px,3vw,30px)] font-bold leading-[1.3] tracking-[-0.01em] text-ink"

export const H3 = "mb-3 text-lg font-bold leading-snug text-ink"

export const LEAD =
  "text-[15px] leading-[1.7] text-ink-secondary sm:text-[17px]"

export const BODY = "text-[15px] leading-[1.7] text-ink-secondary"

/** 圆角按钮（链接或 button 通用） */
export const BTN_BASE =
  "inline-flex items-center justify-center gap-2 rounded-full px-[22px] py-3 text-[15px] font-semibold transition hover:-translate-y-px"

export const BTN_PRIMARY = `${BTN_BASE} bg-primary text-white hover:bg-primary-600`

export const BTN_GHOST = `${BTN_BASE} border border-line bg-white text-ink`

/** 键值列表：左侧定宽标签 + 右侧内容 */
export const KV_LIST = "list-none p-0 m-0"

export const KV_ITEM =
  "flex flex-col gap-0.5 border-b border-dashed border-line py-2.5 text-[15px] last:border-b-0 sm:flex-row sm:gap-4"

export const KV_LABEL = "shrink-0 text-ink-tertiary sm:w-[130px]"

export const KV_VALUE = "font-semibold text-ink [word-break:break-word]"

/** 圆点列表 */
export const DASH_LIST = "list-none p-0 m-0"

export const DASH_ITEM =
  "relative mb-2 pl-[18px] text-[15px] leading-[1.7] text-ink-secondary before:absolute before:left-0 before:top-[11px] before:h-1.5 before:w-1.5 before:rounded-full before:bg-primary"

/** 有序圆点列表 */
export const ORDERED_ITEM =
  "relative mb-2 pl-[26px] [counter-increment:step] text-[15px] leading-[1.7] text-ink-secondary before:absolute before:left-0 before:top-[3px] before:grid before:h-[18px] before:w-[18px] before:place-items-center before:rounded-full before:bg-primary-50 before:text-[11px] before:font-bold before:text-primary before:content-[counter(step)]"

export const ORDERED_LIST = `${DASH_LIST} [counter-reset:step]`

export const TABLE_WRAP =
  "overflow-x-auto rounded-[14px] border border-line bg-white"

export const TH =
  "whitespace-nowrap bg-ink px-4 py-3.5 text-left text-sm font-semibold text-white"

export const TD =
  "px-4 py-3.5 align-top text-[14.5px] leading-[1.6] text-ink-secondary"

export const TAG_BASE =
  "inline-block whitespace-nowrap rounded-full px-2.5 py-0.5 text-[13px] font-semibold"

export const TAG_YES = `${TAG_BASE} bg-[#e6f5ee] text-[#0f7a52]`

export const TAG_MID = `${TAG_BASE} bg-[#fdf3e2] text-[#8a5a09]`

export const TAG_NO = `${TAG_BASE} bg-[#fdecec] text-[#a32b2b]`
